export enum CallOrderCancelationReason {
  CUSTOMER_DEMAND = 'CUSTOMER_DEMAND',
  ITEMS_OUT_OF_STOCK = 'ITEMS_OUT_OF_STOCK',
  NOT_PICKED_UP = 'NOT_PICKED_UP',
  AI_UNRECOGNIZED = 'AI_UNRECOGNIZED',
  OTHER = 'OTHER',
}
